import { render, staticRenderFns } from "./CampaignWizard.vue?vue&type=template&id=0452ad1c&scoped=true&"
import script from "./CampaignWizard.vue?vue&type=script&lang=js&"
export * from "./CampaignWizard.vue?vue&type=script&lang=js&"
import style0 from "./CampaignWizard.vue?vue&type=style&index=0&id=0452ad1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0452ad1c",
  null
  
)

export default component.exports